import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { Common } from '@thecvlb/design-system';
import dayjs from 'dayjs';
import { motion } from 'framer-motion';

import useWidth from 'hooks/useWidth';

import packageInfo from '../../../package.json';

import Vector from 'assets/icons/vector.svg?react';
import BgImage from 'assets/images/auth/sign-in/login-bg-1.webp';
import Logo from 'assets/images/logos/signin.svg?react';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    interdeal: any;
  }
}

const SignIn = ({ children }: PropsWithChildren) => {
  const { isMobile } = useWidth();
  const navigate = useNavigate();

  return isMobile ? (
    <motion.div
      animate={{ opacity: 1 }}
      className="relative h-full"
      initial={{ opacity: 0 }}
      style={{
        background: `linear-gradient(180deg, rgba(0, 105, 139, 0.51) 39%, rgba(0, 112.37, 148.75, 0.85) 69%), url(${BgImage}) no-repeat`
      }}
    >
      <div
        className="absolute top-0 h-1/4 w-full"
        style={{
          background:
            'linear-gradient(180deg, rgba(0.46, 31.13, 41.36, 0.58) 0%, rgba(0.46, 31.13, 41.36, 0) 100%)'
        }}
      />
      <div
        className="absolute bottom-0 h-1/4 w-full"
        style={{
          background:
            'linear-gradient(0deg, rgba(0.46, 31.13, 41.36, 0.58) 0%, rgba(0.46, 31.13, 41.36, 0) 100%)'
        }}
      />
      <div
        className="flex h-full flex-col"
        style={{
          backdropFilter: 'blur(18px)'
        }}
      >
        <div className="relative z-10 flex w-full items-center justify-between py-3 pl-4">
          <button className="w-8" onClick={() => navigate(-1)}>
            <Common.Icon className="size-6 text-white" name="arrow-left" />
          </button>
          <Logo className="mx-auto h-12" />
          <button
            className="rounded-l-full bg-black/30 py-1.5 pl-2.5 pr-2"
            onClick={() => window.interdeal.a11y.openMenu()}
          >
            <Common.Icon className="size-7 text-white" name="accessibility" />
          </button>
        </div>
        <div className="overflow-auto px-4 pt-8">{children}</div>
      </div>
    </motion.div>
  ) : (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-secondary-50">
      <Vector className="vector-animation pointer-events-none absolute inset-0 m-auto size-full" />
      <div
        className="z-10 flex size-fit flex-col items-center rounded-lg border-b-2 border-secondary bg-white p-12 shadow md:w-[396px]"
        data-testid="block_section"
      >
        {children}
      </div>
      <div className="flex flex-col text-center text-xs text-gray">
        <span data-testid="app_version">
          © {dayjs().get('year')} LifeMD, v{packageInfo.version}
        </span>
        <button className="underline" onClick={() => window.interdeal.a11y.openMenu()}>
          Accessibility
        </button>
      </div>
    </div>
  );
};

export default SignIn;
